// @flow
import React from "react";
import GradientBackdropWithVan from "../GradientBackdrop/GradientBackdropWithVan";
import {TechnicalIssueContentContainer, TechnicalIssueContentLabel, TechnicalIssueImage} from "./TechnicalIssueStyle";
import { images } from '../../config';

type OwnProps = {|
    labels: Array<string>
|};

const TechnicalIssue = (props: OwnProps) => {
    return (
        <GradientBackdropWithVan>
            <TechnicalIssueContentContainer>
                <TechnicalIssueImage src={images.oops_icon} alt={"oops"}/>
                {props.labels.map(label =>
                    (<TechnicalIssueContentLabel children={label} key={label}/>)
                )}
            </TechnicalIssueContentContainer>
        </GradientBackdropWithVan>
    );
};

export default TechnicalIssue;



// WEBPACK FOOTER //
// ./src/Components/TechnicalIssue/TechnicalIssue.js